import { render, staticRenderFns } from "./step1.vue?vue&type=template&id=3b45fe5a&scoped=true&"
import script from "./step1.vue?vue&type=script&lang=js&"
export * from "./step1.vue?vue&type=script&lang=js&"
import style0 from "./step1.vue?vue&type=style&index=0&id=3b45fe5a&scoped=true&lang=scss&"
import style1 from "./step1.vue?vue&type=style&index=1&id=3b45fe5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b45fe5a",
  null
  
)

export default component.exports